<template>
	<div v-if="getUnreadCount" data-component="notification-badge" :class="className">
		<tooltip
			:text="getTooltipContent"
			:disabled="hideTooltip"
			position="top"
		>
			<span data-element="notification-count">
				{{ getUnreadCount }}
			</span>
		</tooltip>
	</div>
</template>

<script>
	import Tooltip from '@/components/ui/Tooltip';
	import { pluralizeIntl } from '@/helpers';

	export default {
		components: {
			Tooltip
		},
		props: {
			hideTooltip: {
				type: Boolean,
				default: false
			},
			className: {
				type: String,
				default: undefined
			}
		},
		computed: {
			getUnreadCount () {
				return this.$store.getters['notifications/getUnreadCount'];
			},
			getTooltipContent () {
				if (this.hideTooltip) {
					return '';
				}

				if (this.getUnreadCount) {
					return pluralizeIntl(
						this.getUnreadCount,
						'unread notification',
						'unread notifications'
					);
				}

				return '';
			}
		}
	};

</script>

<style lang="scss" scoped>

[data-component="notification-badge"] {
	display: inline-flex;

	::v-deep [data-element="tooltip-text-wrapper"] {
		min-height: rem(20);
		min-width: rem(130);
		margin-inline-start: -73px !important;

		[data-element="tooltip-text"] {
			font-size: 12px !important;
			font-weight: 400 !important;
			line-height: 14px !important;
		}
	}

	[data-element="notification-count"] {
		display: inline-flex;
		min-width: 20px;
		height: 20px;
		padding: 0 4px;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
		background-color: $c-red-l;
		@include font(14px, #fff, 500, 20px);
	}
}

</style>
